import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonBackButton,
  IonBadge,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { Router } from '@angular/router';

import { NotificationService } from '@/app/core/api/notification.service';
import { authService } from '@/app/core/auth/auth.service';

@Component({
  selector: 'bevme-header',
  standalone: true,
  imports: [CommonModule, IonBackButton, IonBadge, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon],
  templateUrl: './bevme-header.component.html',
  styleUrls: ['./bevme-header.component.scss'],
})
export class BevmeHeaderComponent implements OnInit {
  @Input() logoSrc = 'assets/img/BevmeLongLogo.png';
  @Input() showBack = false;
  @Input() showPeopleSearch = true;
  @Input() showNotifications = true;
  @Input() backIconName = 'chevron-back';
  @Input() backAriaLabel = 'Back';
  /** Explicit route to navigate back to. Falls back to NavController.back() if not set. */
  @Input() backRoute: string | null = null;

  readonly unreadCount$ = this.notifications.unreadCount$;

  constructor(
    private readonly router: Router,
    private readonly notifications: NotificationService,
  ) {}

  ngOnInit(): void {
    if (this.canShowNotifications()) {
      this.notifications.startUnreadPolling();
    }
  }

  canShowNotifications(): boolean {
    return this.showNotifications && authService.isAuthenticated();
  }

  canShowPeopleSearch(): boolean {
    return this.showPeopleSearch && !this.showBack;
  }

  openNotifications(): void {
    void this.router.navigate(['/tabs/notifications'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  openPeopleSearch(): void {
    void this.router.navigate(['/tabs/people'], {
      queryParams: { returnUrl: this.router.url },
    });
  }
}
